export default __webpack_public_path__ + "static/media/3crackers.2a0311e2.svg";